/* eslint-disable */
import React from 'react'
import PropTyps from 'prop-types'
import {Route, Redirect} from 'react-router-dom'

class PrivateRoute extends React.Component {
  static propTypes = {
    component: PropTyps.func.isRequired,
    patch: PropTyps.string.isRequired
  }
  constructor(props) {
    super(props)
  }

  componentDidMount() {}

  render() {
    const {component: Component, auth: isAuthenticate, ...restProps} = this.props
    return (
      <Route
        {...restProps}
        render={(props) =>
          isAuthenticate ? <Component {...props} /> : <Redirect to={{pathname: '/', state: {from: props.location}}} />
        }
      />
    )
  }
}
export default PrivateRoute
